/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import moment from 'moment'

import {
  Spinner,
  Warning
} from '../'

import {
  decodeBase64
} from '../../utils'

class ObjectMetric extends React.Component {
  static propTypes = {
    objectId: PropTypes.string,
    identityId: PropTypes.string,
    metricSourceId: PropTypes.string.isRequired,
    createdAt: PropTypes.string,  // date in YYYY-MM-DD format
    children: PropTypes.func.isRequired
  }

  render() {
    let { data: { loading, error, metrics }, children } = this.props

    if (loading) {
      return (
        <Spinner type='tail' />
      )
    }

    if (error) {
      return (
        <Warning iconSize='x-small'>
          Error loading metric.
        </Warning>
      )
    }

    if (metrics.edges.length === 0) {
      return children(null)
    }

    let metric = metrics.edges[0].node
    return children(metric)
  }
}

const getMetrics = gql`
  query($objectId: UUID, $identityId: UUID, $metricSourceId: UUID!, $createdAtStart: DateTime!, $createdAtEnd: DateTime!) {
    metrics(relations_ObjectId: $objectId, identity_Id: $identityId, metricsource_Id: $metricSourceId, createdAt_Gte: $createdAtStart, createdAt_Lte: $createdAtEnd, orderBy: "-created_at", first: 1) {
      edges {
        node {
          id
          description
          result
          createdAt
        }
      }
    }
  }
`

const withData =
  graphql(getMetrics, {
    options: ({ objectId, metricSourceId, identityId, createdAt }) => ({
      variables: {
        objectId: objectId
          ? decodeBase64(objectId)
          : null,
        identityId: identityId
          ? decodeBase64(identityId)
          : null,
        metricSourceId: decodeBase64(metricSourceId),
        createdAtStart: createdAt
          ? `${createdAt}T00:00:00`
          : `${moment().format('YYYY-MM-DD')}T00:00:00`,
        createdAtEnd: createdAt
          ? `${createdAt}T23:59:59`
          : `${moment().format('YYYY-MM-DD')}T23:59:59`
      },
      notifyOnNetworkStatusChange: true
    })
  })

export default withData(ObjectMetric)



// WEBPACK FOOTER //
// ./src/components/object-metric/index.js